<template>
  <!-- MODAL Lighting -->
  <b-modal
    id="Lora"
    :title="waydetail"
    size="xl"
    ok-title="ตกลง"
    ok-only
  >
    <template>
      <b-col
        lg="12"
        md="12"
        sm="12"
      >
        <b-card style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: 610px; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
          <div>
            <b-row>
              <b-col
                lg="12"
                md="12"
              >
                <l-map
                  ref="mymap1"
                  :zoom="zoom"
                  :center="center"
                  :options="{scrollWheelZoom:false, zoomControl: true, attributionControl:false}"
                >
                  <l-tile-layer :url="url" />
                  <l-marker
                    v-for="(marker1, index) in markerKerlink"
                    :key="'marker'+index"
                    :ref="'marker'+index"
                    :lat-lng="[marker1.lat, marker1.long]"
                    :options="{ autoClose: false, closeOnClick: false }"
                    @click="getInfo(marker1.gwno, marker1.ipaddress, marker1.lastupdate)"
                  >
                    <l-icon
                      :icon-size="[50, 80]"
                      :icon-anchor="[16, 37]"
                      :icon-url="require('@/assets/images/icons/gateway.gif')"
                    />
                    <l-popup>
                      <div>
                        <b-table
                          style="width: 16rem; font-size:15px;"
                          responsive="sm"
                          :items="itemsInfo"
                          :fields="fieldss"
                          small
                          stacked
                        />
                      </div>
                    </l-popup>
                  </l-marker>
                </l-map>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>
      <b-col
        lg="12"
        md="12"
        sm="12"
      >
        <b-card
          no-body
          style="background-color: rgb(255, 127, 96, 0.0)"
        >
          <b-row>
            <b-col
              lg="3"
              md="12"
              sm="12"
              xs="12"
              class="d-flex align-items-center justify-content-end text-sm-right mb-1"
            >
              <label>ค้นหา</label>
              <b-input-group
                size="sm"
                style="padding-left:14px;"
              >
                <b-form-input
                  id="filterInput"
                  v-model="filter"
                  type="search"
                  placeholder="ป้อนคำที่ต้องการค้นหา.."
                  label-cols-sm="12"
                  label-cols-md="2"
                  label-cols-lg="2"
                  style="background-color: rgb(255, 127, 96, 0.0)"
                />
                <b-input-group-append>
                  <b-button
                    :disabled="!filter"
                    @click="filter = ''"
                  >
                    ล้าง
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col cols="12">
              <b-table
                responsive
                :per-page="perPage"
                :current-page="currentPage"
                :items="items"
                :fields="fields"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                :filter="filter"
                :filter-included-fields="filterOn"
                style="background-color:rgba(0, 22, 45, 0.1);"
                @filtered="onFiltered"
              >
                <template #cell(pc_server_offline)="data">
                  <span
                    v-if="data.item.pc_server_offline !== 0"
                    style="color:red"
                  >
                    {{ data.item.pc_server_offline }}
                  </span>
                  <span
                    v-if="data.item.pc_server_offline === 0"
                  >
                    {{ data.item.pc_server_offline }}
                  </span>
                </template>
                <template #cell(ISOnline)="data">
                  <b-badge :variant="ISOnline[1][data.value]">
                    {{ ISOnline[0][data.value] }}
                  </b-badge>
                </template>
              </b-table>
            </b-col>
            <b-col
              cols="12"
            >
              <b-card-body class="d-flex justify-content-between flex-wrap pt-1">

                <!-- page length -->
                <b-form-group
                  label="Per Page"
                  label-cols="6"
                  label-align="left"
                  label-size="sm"
                  label-for="sortBySelect"
                  class="text-nowrap mb-md-0 mr-1"
                >
                  <b-form-select
                    id="perPageSelect"
                    v-model="perPage"
                    size="sm"
                    inline
                    :options="pageOptions"
                    style="background-color: rgb(255, 127, 96, 0.0)"
                  />
                </b-form-group>

                <!-- pagination -->
                <div>
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    first-number
                    last-number
                    prev-class="prev-item"
                    next-class="next-item"
                    class="mb-0"
                  >
                    <template #prev-text>
                      <feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                      />
                    </template>
                    <template #next-text>
                      <feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                      />
                    </template>
                  </b-pagination>
                </div>
              </b-card-body>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </template>
  </b-modal>
</template>

<script>
/* eslint-disable global-require */
import {
  BRow, BCol, BTable, BFormGroup, BCard,
  BFormSelect, BPagination, BCardBody, BBadge,
  BButton, BInputGroupAppend, BInputGroup, BFormInput,
} from 'bootstrap-vue'
import axios from '@axios'
import {
  LMap, LTileLayer, LMarker, LIcon, LPopup,
} from 'vue2-leaflet'
import { Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen'
// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BFormGroup,
    BFormSelect,
    BPagination,
    BCardBody,
    BButton,
    BInputGroupAppend,
    BInputGroup,
    BCard,
    BFormInput,
    BBadge,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LPopup,
  },
  data() {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 12,
      center: [0, 0],
      items: [],
      fields: [
        {
          key: 'gwno', label: 'ลำดับ', sortable: true, class: 'text-center',
        },
        {
          key: 'ipaddress', label: 'ipaddress', sortable: true, class: 'text-center',
        },
        {
          key: 'ISOnline', label: 'สถานะ', sortable: true, class: 'text-center',
        },
        {
          key: 'lastupdate', label: 'อัพเดตล่าสุด', sortable: true, class: 'text-center',
        },
      ],
      itemsInfo: [],
      fieldss: [
        {
          key: 'gwno', label: 'ลำดับ', sortable: true, class: 'text-center',
        },
        {
          key: 'ipaddress', label: 'ipaddress', sortable: true, class: 'text-center',
        },
        {
          key: 'lastupdate', label: 'อัพเดตล่าสุด', sortable: true, class: 'text-center',
        },
      ],
      deptname: '',
      // --------history--------
      perPage: 25,
      pageOptions: [25, 50, 100],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      waydetail: '',
      markerKerlink: [],
      ISOnline: [{
        Offline: 'Offline', Online: 'Online',
      },
      {
        Offline: 'danger', Online: 'success',
      }],
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
  },
  mounted() {
    this.interval = setInterval(() => {
      this.getTableLoraWanDetail()
      this.getMarkerKerlink()
    }, 300000)
  },
  methods: {
    getMarkerKerlink() {
      axios
        .post('/modalLoraWan', { wid: this.$route.query.wid })
        .then(response => {
          this.markerKerlink = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getStatus() {
      axios
        .post('/getStatusSEM', { wid: this.$route.query.wid })
        .then(response => {
          this.center.splice(0)
          this.waydetail = `Kerlink:  ${response.data[0].detail}`
          this.center.push(response.data[0].latitude)
          this.center.push(response.data[0].longitude)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getTableLoraWanDetail() {
      setTimeout(() => {
        this.$refs.mymap1.mapObject.invalidateSize()
        this.getStatus()
        this.getMarkerKerlink()
      }, 100)
      axios
        .post('/modalLoraWan', { wid: this.$route.query.wid })
        .then(response => {
          this.items = response.data
          this.totalRows = response.data.length
        })
    },
    getInfo(gwno, ipaddress, lastupdate) {
      this.itemsInfo.splice(0)
      this.itemsInfo.push({
        gwno,
        ipaddress,
        lastupdate,
      })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>

<style lang="scss">
  .vue2leaflet-map {
      &.leaflet-container{
      width: 100%;
      height: 568px;
      }
  }
.table-responsive{
    font-size: 14px;
}
.table thead th {
  font-size: 14x;
}
</style>
